import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { TIMELINE } from "../data/content";
import { MaskedLines, FadeUp } from "./Reveal";

const Card = ({ t, i }) => (
  <div
    className="glass group relative w-[20rem] shrink-0 rounded-3xl p-7 transition-transform duration-300 hover:-translate-y-2 md:w-[24rem]"
    data-testid={`timeline-card-${i}`}
  >
    <p className="font-display text-5xl font-black tracking-tight text-[#0A192F] md:text-6xl">{t.year}</p>
    <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.22em] text-[#0A192F]/45">{t.span}</p>
    <div className="mt-5 border-t border-[#0A192F]/10 pt-5">
      <p className="font-display text-lg font-black uppercase tracking-wide text-[#0A192F]">{t.company}</p>
      <p className="mt-1 text-sm font-bold text-[#00BFA5]">{t.role}</p>
      <p className="mt-3 text-sm leading-relaxed text-[#4A5568]">{t.note}</p>
    </div>
  </div>
);

export const Timeline = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref });
  const x = useTransform(scrollYProgress, [0, 1], ["4%", "-78%"]);

  return (
    <section id="experience" data-testid="career-timeline" className="relative bg-[#0A192F]">
      <div ref={ref} className="relative hidden h-[320vh] md:block">
        <div className="spotlight-dark sticky top-0 flex h-screen flex-col justify-center overflow-hidden">
          <div className="mx-auto w-full max-w-7xl px-10">
            <p className="text-xs font-bold uppercase tracking-[0.32em] text-[#00E5FF]">Career Timeline</p>
            <h2 className="mt-4 font-display text-4xl font-black tracking-tight text-white md:text-6xl">
              <MaskedLines lines={["Travel through the years"]} />
            </h2>
          </div>
          <div className="relative mt-16">
            <div className="absolute left-0 right-0 top-1/2 h-px bg-gradient-to-r from-[#00E5FF]/40 via-white/20 to-[#00BFA5]/40" />
            <motion.div style={{ x }} className="flex gap-10 pl-[6vw]">
              {TIMELINE.map((t, i) => (
                <Card key={t.year} t={t} i={i} />
              ))}
            </motion.div>
          </div>
        </div>
      </div>

      <div className="spotlight-dark px-6 py-20 md:hidden">
        <p className="text-xs font-bold uppercase tracking-[0.32em] text-[#00E5FF]">Career Timeline</p>
        <h2 className="mt-4 font-display text-4xl font-black tracking-tight text-white">
          <MaskedLines lines={["Travel through the years"]} />
        </h2>
        <div className="mt-10 space-y-6 border-l border-white/15 pl-6">
          {TIMELINE.map((t, i) => (
            <FadeUp key={t.year} delay={i * 0.08}>
              <Card t={t} i={i} />
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
